import moment from "moment";

class Present {
	ordinal(value) {
		value = parseInt(value);
		let j = value % 10,
			k = value % 100;
		if (j == 1 && k != 11) {
			return value + "st";
		}
		if (j == 2 && k != 12) {
			return value + "nd";
		}
		if (j == 3 && k != 13) {
			return value + "rd";
		}
		return value + "th";
	}

	ucWords(value) {
		let snakeCase = value.replace(/[A-Z]/g, letter => "_" + letter).toLowerCase();
		return snakeCase.replace(/_/g, " ").split(" ").map((word) => {
			if (!isNaN(word)) {
				return word;
			}
			return word[0].toUpperCase() + word.substring(1);
		}).join(" ");
	}

	lcWords(value) {
		let snakeCase = value.replace(/([A-Z][a-z])\w+/g, letter => "_" + letter.toLowerCase());
		return snakeCase.replace(/_/g, " ");
	}

	upper(value) {
		return this.lcWords(value).toUpperCase();
	}

	lower(value) {
		return this.lcWords(value).toLowerCase();
	}

	dateTime(dateTime) {
		return moment(dateTime).format("DD/MM/YYYY [at] HH:mm");
		return moment(dateTime).format("Do MMM YYYY [at] HH:mm");
	}

	date(dateTime) {
		return moment(dateTime).format("Do MMM YYYY");
	}

	time(dateTime) {
		return moment(dateTime).format("HH:mm");
	}

	duration(duration) {
		let mDuration = moment.duration(duration.s, "seconds");

		return [
			("00" + mDuration.hours()).slice(-2),
			("00" + mDuration.minutes()).slice(-2),
			("00" + mDuration.seconds()).slice(-2),
		].join(":");
	}

	fullName(object) {
		if (!object) {
			return "—";
		}

		return [object.title, object.name_first, object.name_middle, object.name_last].join(" ").trim();
	}

	initials(object) {
		return [object.name_first.substr(0, 1), object.name_last.substr(0, 1)].join("");
	}

	priceOrPercent(object, type, symbol = true) {
		if (!type) {
			type = object.percent ?
				"percent" :
				"price";
		}

		return this[type](object, symbol);
	}

	price(value, options = {}) {
		if (value === null) {
			return "—";
		}

		value = _.isObject(value) ? value.float : value;

		return new Intl.NumberFormat("en-UK", Object.assign({
			style: "currency",
			currency: "GBP",
			useGrouping: "min2",
			maximumFractionDigits: value.toString().includes(".") ? 2 : 0,
		}, options)).format(value);
	}

	priceWholes(object, symbol = true) {
		return this.price(object);
	}

	percent(object, symbol = true, precision = 2) {
		if (!_.isObject(object)) {
			object = {
				percent: object,
			};
		}

		return Math.round(object.percent) + (symbol ? "%" : "");
	}

	uri(object) {
		return object.uri || null;
	}

	activityName(string) {
		let labels = {
			calls: "Calls",
			notes: "Notes",
			todo: "To-Do",
		};

		return labels[string];
	}

	requirementName(string) {
		let labels = {
			appointment: "Appointment",
			fact_find: "Fact Find",
			payment: "Payment",
		};

		return labels[string];
	}

	calendar(string) {
		let labels = {
			appointments: "Appointments",
			callbacks: "Callbacks",
			holidays: "Holidays",
		};

		return labels[string];
	}

	paragraphs(text) {
		return "<p>" + text.split(/[\n]{2,}/gm).map(function (multiline) {
			return multiline.split(/[\n]/gm).join("<br>");
		}).join("</p><p>") + "</p>";
	}

	clientName(client) {
		if (!client.name_first && !client.name_last) {
			return "—";
		}

		return [
			client.title,
			client.name_first,
			client.name_middle,
			client.name_last,
		].join(" ");
	}

	ntext(singular, plural, count) {
		let string = 1 === count ? singular : plural;
		return string.replace("#", count);
	}

	address(address) {
		return address;
	}
}

export default {
	methods: {
		$present(...args) {
			return new Present()[args.shift()](...args);
		},
	},
};
